export default "__VITE_ASSET__BKMwirJ9__"